const __version__ ='alight_external_transperancy_v2.0'

module.exports = {
    __version__
}

